const idOf = value => {
  if (value == null) return '';
  if (typeof value === 'object') {
    if (value._id != null) return String(value._id);
    return String(value);
  }
  return String(value);
};

export default function ackBelongsToEmployee(ack, employee) {
  const ackId = idOf(ack?.user);
  const empId = idOf(employee?.user_id || employee?.user?._id || employee?.user);
  return Boolean(ackId && empId && ackId === empId);
}
